import React, {useCallback, useState} from 'react'
import {Modal} from 'antd'
import {CheckOutlined} from '@ant-design/icons'

import useUserContext from 'components/User/useUserContext'

const AddressEditor = ({t, data, fixed, children}) => {
  const {delivery, setDelivery} = useUserContext()

  const [editing, setEditing] = useState(false)

  const onClickSelectAddress = useCallback(_ => (
    !fixed ? setDelivery(data) : false
  ), [data, fixed, setDelivery])

  return (
    <div
      className={`addressEditor ${
        (!fixed && setDelivery) ? 'addressEditor-selectable' : ''
      } ${
        (!fixed && delivery?.uuid === data.uuid) ? 'addressEditor-selected' : ''
      }`}
      onClick={onClickSelectAddress}
    >
      {fixed && <button onClick={_ => setEditing(true)}>{t('edit')}</button>}
      {!fixed && delivery?.uuid === data.uuid && <div className='addressEditor-check'><CheckOutlined/></div>}

      <p title={data.contactName}>{data.contactName}</p>
      <p title={data.streetAddress1}>{data.streetAddress1}</p>
      <p title={data.streetAddress2}>{data.streetAddress2}</p>
      <p title={data.city}>{data.zip && data.city ? <>{data.zip}, {data.city}</> : <>{data.zip} {data.city}</>}</p>

      {editing && (
        <Modal visible footer={null} onCancel={_ => setEditing(false)}>
          {children}
        </Modal>
      )}
    </div>
  )
}

export default AddressEditor
